'use client';

import { useDebugMode } from '@/lib/hooks/useDebugMode';

interface DebugEditButtonProps {
  imageName: string;
  imageUrl: string;
  position?: 'top-right' | 'top-left' | 'bottom-right' | 'bottom-left';
}

export function DebugEditButton({ 
  imageName, 
  imageUrl, 
  position = 'bottom-right'
}: DebugEditButtonProps) {
  const isDebugMode = useDebugMode();
  
  if (!isDebugMode) {
    return null;
  }
  
  const positionClasses = {
    'top-right': 'top-4 right-4',
    'top-left': 'top-4 left-4',
    'bottom-right': 'bottom-4 right-4',
    'bottom-left': 'bottom-4 left-4'
  };
  
  const handleClick = () => {
    // Create a custom event to open the debug overlay
    const event = new CustomEvent('openDebugOverlay', { 
      detail: { 
        imageName: imageName || imageUrl.split('/').pop()?.split('.')[0] || '',
        imageUrl: imageUrl 
      } 
    });
    window.dispatchEvent(event);
  };
  
  return (
    <button
      onClick={handleClick}
      className={`absolute ${positionClasses[position]} bg-black/90 p-2 rounded-full opacity-0 group-hover:opacity-100 transition-opacity z-50`}
      title="Open Debug Overlay"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M12 20h9" />
        <path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z" />
      </svg>
    </button>
  );
}